import React, { useState, useRef, KeyboardEvent } from 'react';
import { Send } from 'lucide-react';
import { Button } from '../../../../components/common/Button';

interface MessageInputProps {
  isVisible?: boolean;
  sendUserMessage: (message: string) => void;
}

const MessageInput: React.FC<MessageInputProps> = ({ 
  isVisible = true,
  sendUserMessage
}) => {
  const [message, setMessage] = useState<string>('');
  
  const handleSubmit = () => {
    if (message.trim()) {
      sendUserMessage(message);
      setMessage('');
    }
  };
  
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="border border-border-light dark:border-border-dark bg-surface-light/50 dark:bg-surface-dark/50 rounded-lg backdrop-blur-lg w-full max-w-md mx-auto pr-1">
    <div className="flex items-center space-x-2">
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Write your message here.."
        className="flex-1 px-3 py-2 text-sm rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-light dark:focus:ring-primary-dark resize-none h-10 min-h-[2.8rem] pt-3"
      />
      <Button
        onClick={() => {
          sendUserMessage(message);
          setMessage('');
        }}
        variant="primary"
        disabled={!message.trim()}
        size="sm"
        className="h-9 w-9"
      >
        <Send className="w-4 h-4" />
      </Button>
    </div>
  </div>
  );
};

export default MessageInput; 